import { render, staticRenderFns } from "./SingleNotification.vue?vue&type=template&id=92283626"
import script from "./SingleNotification.vue?vue&type=script&lang=ts"
export * from "./SingleNotification.vue?vue&type=script&lang=ts"
import style0 from "./SingleNotification.vue?vue&type=style&index=0&id=92283626&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCheckbox,VDivider,VHover,VIcon,VListItem,VListItemAction,VListItemContent})
